/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_Art_BodyInputs */

const en_services_svc_research_art_body = /** @type {(inputs: Services_Svc_Research_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most clinics take bookings by phone, and few offer online booking. Price lists are rarely published, and reviews mention waiting times most often.`)
};

const lv_services_svc_research_art_body = /** @type {(inputs: Services_Svc_Research_Art_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lielākā daļa klīniku pieraksta pa tālruni, tiešsaistes pierakstu piedāvā retā. Cenrāži publicēti reti, atsauksmēs visbiežāk minēts gaidīšanas laiks.`)
};

/**
* | output |
* | --- |
* | "Most clinics take bookings by phone, and few offer online booking. Price lists are rarely published, and reviews mention waiting times most often." |
*
* @param {Services_Svc_Research_Art_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_art_body = /** @type {((inputs?: Services_Svc_Research_Art_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_Art_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_art_body(inputs)
	return en_services_svc_research_art_body(inputs)
});